import React from "react";
import {
  EnumHelper,
  NumberHelper,
  DateHelper,
  ImageHelper,
} from "../../../../common/Helpers";
import {
  SystemSettingKeys,
  ProgrammeAvailabilitiesEnum,
} from "../../../../common/Constants";
import RestClient from "../../../../common/RestClient";
import { getMovieClassifyCssClassById } from "../../../../common/Common";
import "./FilmFestivalPreview.scss";
import { SystemSettings } from "../../../../common/SystemSettings";

const CLASSIFICATION_CSS_CLASSES = {
  G: "sprite-legends-rating-G",
  PG: "sprite-legends-rating-pg",
  PG13: "sprite-legends-rating-pg13",
  NC16: "sprite-legends-rating-nc16",
  M18: "sprite-legends-rating-m18",
  R21: "sprite-legends-rating-r21",
};

const getClassifyCssClass = (movieRelease) => {
  if (!movieRelease?.classify) {
    const code = (movieRelease.classifyCode || "").toString().toUpperCase();
    return CLASSIFICATION_CSS_CLASSES[code] || "";
  }
  return getMovieClassifyCssClassById(movieRelease.classify);
};

export class ProgrammeCardPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cachedReleases: [], program: props.programmes };
  }

  componentDidMount() {
    this.loadMovieReleaseDetails(this.state.program?.movieReleaseId);
  }

  loadMovieReleaseDetails(id) {
    RestClient.sendGetRequestWithParameters(
      `/api/v1/movie_releases/summary`,
      { movieReleaseIds: `${id}` },
      (response) => {
        let { cachedReleases } = this.state;
        response.data.forEach((item) => {
          if (
            cachedReleases.findIndex(
              (evt) => evt.movieReleaseId === item.movieReleaseId
            ) === -1
          ) {
            cachedReleases.push(item);
          }
        });
        this.setState({ cachedReleases });
      }
    );
  }

  render() {
    const { programmes } = this.props;
    const { cachedReleases } = this.state;
    const movieRelease = cachedReleases?.[0];
    const enableInCinema = EnumHelper.hasFlag(
      programmes?.programmeAvailabilities,
      ProgrammeAvailabilitiesEnum.Cinema
    );
    const enableKinoLounge = EnumHelper.hasFlag(
      programmes?.programmeAvailabilities,
      ProgrammeAvailabilitiesEnum.KinoLounge
    );
    const movieReleaseLink = `${
      SystemSettings.get(SystemSettingKeys.PublicWebsiteUrl) || ""
    }/movie-details/${movieRelease?.movieReleaseId}`;
    const classifyClass = getClassifyCssClass(movieRelease);

    return (
      <div className="film-festival-preview__movie">
        <div className="movie_list_poster">
          <div className="movies_ct-item">
            <a
              className="block-img p-t-0"
              href={movieReleaseLink}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={ImageHelper.getPosterUrl(movieRelease?.poster)}
                alt={movieRelease?.name}
                onError={ImageHelper.onPosterError}
              />
            </a>
          </div>
        </div>
        <div className="list_movies">
          <div className="info">
            <a
              href={movieReleaseLink}
              className="title"
              target="_blank"
              rel="noreferrer"
            >
              {movieRelease?.name}
            </a>
            <p>
              {classifyClass && (
                <span>
                  <span className={`${classifyClass} mr-1 float-left`} />
                </span>
              )}
              <span className="movie-duration">
                | {NumberHelper.formatRuntime(movieRelease?.duration)}
              </span>
            </p>
            <div className="list_text_div">
              <div
                className="list_text_description"
                dangerouslySetInnerHTML={{
                  __html: movieRelease?.plotSummary,
                }}
              />
              <a href={movieReleaseLink} target="_blank" rel="noreferrer">
                <span className="list_text_link">(Details)</span>
              </a>
            </div>
          </div>
        </div>
        <div className="film-festival-preview__movie-meta">
          <div>
            <label className="form-control-label pl-0 col-5">
              Sales Start:
            </label>
            <label className="form-check-label pl-0 col-6">
              {DateHelper.formatDateTimeString(programmes?.salesStartTime)}
            </label>
          </div>
          <div>
            <label className="form-control-label pl-0 col-5">Sales End:</label>
            <label className="form-check-label pl-0 col-6">
              {DateHelper.formatDateTimeString(programmes?.salesEndTime)}
            </label>
          </div>
          <div className="row">
            <label className="form-control-label col-5">
              Film Availability:
            </label>
            <ul className="col-5" style={{ paddingLeft: "30px" }}>
              {enableInCinema && <li>Cinema</li>}
              {enableKinoLounge && <li>KinoLounge</li>}
            </ul>
          </div>
          {enableKinoLounge && (
            <div className="row">
              <label className="form-control-label col-5">
                KinoLounge Link:
              </label>
              <a
                className="col-6 short-link"
                href={programmes?.kinoLoungeUrl}
                target="_blank"
                rel="noreferrer"
              >
                {programmes?.kinoLoungeUrl}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}
